<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    
    <div class="row pt-2 equal-cols" style="width: 120%" >
      <div class="col-md-12">
        <section class="card mb-2">

          <div class="card-body">

            <div class="tabbed">
              <input type="radio" :id="'tab' + i +'b'" name="css-tabs3" v-for="(s, i) in myScenicAreaList.filter(s =>s.id != 18 )" :key="i+'a'" :checked="i === 0">
              <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box tabs">
                <li class="tab  px-0  nav-item" v-for="(s, i) in myScenicAreaList.filter(s =>s.id != 18 )" :key="i+'m'">
                  <label class="nav-link py-1" :for="'tab'+i+'b'" >{{s.name}}</label>
                </li>
              </ul>
              <!--  不顯示"秘書室"這個景區  地圖不顯示，即時影像要顯示-->
              <div class="tab-content" v-for="(scenicArea, i) in myScenicAreaList.filter(s =>s.id != 18 )" :key="i">
                <div id="map-container-google-1" class="z-depth-1-half map-container" v-if="!myScenicAreaList.isDeleted" >
                  <map-map :scenicAreaId='scenicArea.id'></map-map>
                </div>
              </div>
            </div>
  
          </div>
        </section>
      </div>
    </div>
    
  </div>
</template>

<script>
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import {mapState, mapGetters} from 'vuex'
import MapMap from '../map/index'

export default {
  name: "Home",
  components: {
   
    MapMap
  },
  data() {
    return {
      CONST: CONST,
      Utils: Utils,
      dataInterval: null,

    };
  },

  computed: { 
    ...mapState('scenicArea', {scenicAreaList: 'allscenicArea'}),
    ...mapGetters('scenicArea', {myScenicAreaList: 'getMyScenicArea'})

  },
  watch: {
    myScenicAreaList() {
      // console.log('myScenicAreaList', this.myScenicAreaList)
      // this.getAllData() ///有可能是這個function 擋住
    },

  },
  methods: {

  },
  async mounted() {

  },
  destroyed() {

  }
};
</script>
<style lang="scss" scoped>

//在site.css tabs 有長度限制
//site.css: 577  .tabbed [type="radio"]:nth-of-type(1):checked ~ .tabs .tab:nth-of-type(1) label

$max: 50;
@for $i from 1 through $max {
  .tabbed [type="radio"]:nth-of-type(#{$i}):checked ~ .tabs .tab:nth-of-type(#{$i}) label {
    background:#00ae9a !important;
    color: #fff;
  }

  .tabbed [type="radio"]:nth-of-type(#{$i}):checked ~ .tabs .tab:nth-of-type(#{$i}) label:after {
    -webkit-transform: scale(1);
    transform: scale(1);
  }


}


//site.css: 586 tabbed [type="radio"]:nth-of-type(1):checked ~ .tab-content:nth-of-type(1)
@for $i from 1 through $max {
  .tabbed [type="radio"]:nth-of-type(#{$i}):checked ~ .tab-content:nth-of-type(#{$i}) {
    display: block;
    box-shadow: none;
  }
}

.nav-tabs li .nav-link:hover{
  background-color: #00ae9a;
  color:#fff;
  border-bottom: 0.8px solid #EEE;
  border-top: 0.8px solid #EEE;

  // border:1px !important;
}






</style>
